import { Col, Container, Row } from 'react-grid-system';
import styled from 'styled-components';
import { Outlet } from 'react-router';
import { pathURL } from '@/components/constants/urls';
import { useUserLanguage } from '@/customHooks';
import NavTabs from '../molecules/NavTabs';

const textsData = {
  en: {
    title: 'Contacts',
    buttonText: '+ Add Tenant'
  },
  es: {
    title: 'Contactos',
    buttonText: '+ Agregar Inquilino'
  }
}

const ButtonContainer = styled(Col)`
  display: flex;
  align-items: center;
`

export const ContactsPage = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en
  
  return (
    <Container fluid>
      <Row>
        <Col>
            <h1>{texts.title}</h1>
        </Col>
        <ButtonContainer xs="content">
          <NavTabs
            tabs={[
              { label: "Tenants", href: `/${pathURL.USER}/${pathURL.CONTACTS}/${pathURL.TENANT}` },
              { label: "Owners", href: `/${pathURL.USER}/${pathURL.CONTACTS}/${pathURL.OWNER}` },
              { label: "Suppliers", href: `/${pathURL.USER}/${pathURL.CONTACTS}/${pathURL.SUPPLIER}` },
            ]}
            defaultActive="Tenants"
          />
        </ButtonContainer>
      </Row>
      <Row>
        <Col>
          <Outlet />
        </Col>
      </Row>
    </Container>
  )
}
